// RsvpClosed.js
//
// The wedding took place on 27 July 2025. Until now /rsvp still served a live
// form asking guests to respond by 30 March 2025 — a deadline over a year past,
// for a day that has already happened.
//
// The original form in Rsvp.js is deliberately left untouched on disk rather
// than deleted: restoring it is a one-line change to the route in App.js.
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaHeart, FaImages, FaBabyCarriage } from 'react-icons/fa';
import './RsvpClosed.css';

const RsvpClosed = () => {
  const { t } = useTranslation();

  return (
    <div className="rsvp-closed-page">
      <div className="rsvp-closed-card">
        <FaHeart className="rsvp-closed-icon" aria-hidden />

        <h1>{t('rsvpClosed.title', 'Takk for at dere feiret med oss')}</h1>

        <p className="rsvp-closed-date">{t('hero.date')}</p>

        <p className="rsvp-closed-body">
          {t(
            'rsvpClosed.body',
            'Bryllupet er over, og påmeldingen er stengt. Tusen takk til alle som kom og gjorde dagen uforglemmelig.'
          )}
        </p>

        <div className="rsvp-closed-actions">
          <Link to="/photos" className="rsvp-closed-btn primary">
            <FaImages aria-hidden /> {t('rsvpClosed.viewPhotos', 'Se bildene')}
          </Link>
          <Link to="/baby-reveal" className="rsvp-closed-btn">
            <FaBabyCarriage aria-hidden /> {t('rsvpClosed.babyReveal', 'Baby reveal')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RsvpClosed;
